<div>
  <mic-breadcrumb id="cam-spec-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/specifications" label="{{ translationService.translate('camSpecsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 class="m-0 mt-3" id="cam-spec-heading">{{ translationService.translate('searchCAMSpecificationsHeadingText') }}</h3>

  <mat-card class="search-card mt-3">
    <div class="search-row w-full">
      <div class="justify-self-start">
        <mat-form-field id="search-field" subscriptSizing="dynamic">
          <mat-label>{{ translationService.translate('searchByCAMSpecText') }}</mat-label>
          <input type="text" matInput [formControl]="search" autocomplete="off" (keydown.enter)="onSearchClick()" />
          <button id="search-icon" (click)="onSearchClick()" mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="flex">
        @if (hasEditPermission) {
        <button id="create-button" mat-flat-button color="primary" (click)="navigateToCreateCamSpec()">
          <mat-icon>add</mat-icon>
          {{ translationService.translate('createCamSpecButtonText') }}
        </button>
        }
      </div>
    </div>
  </mat-card>

  <div id="cam-spec-table" class="cam-table mt-2">
    <mic-table
      appCopyOnSelect
      #paginatedTable
      class="table-stripped btn-table"
      [config]="tableConfig"
      [filtersConfig]=""
      [fetcher]="fetcher"
    >
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
      </ng-container>

      <ng-container *micTableColumnSelector>
        <button
          id="table-column-selector"
          mat-flat-button
          [matMenuTriggerFor]="colMenu"
          (click)="$event.stopPropagation()"
          class="column-button"
        >
          <mat-icon>view_column</mat-icon>{{ translationService.translate('columnsButtonText') }}
        </button>
        <mat-menu #colMenu="matMenu">
          <div style="padding: 8px 16px; max-width: 320px">
            <div *ngFor="let key of columnKeys">
              <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">{{
                columnNames[key] || key
              }}</mat-checkbox>
            </div>
          </div>
        </mat-menu>
      </ng-container>

      <ng-container *micTableActions="let items">
        <div class="footer flex flex-row justify-center items-center">
          <div id="table-items-selected" class="mr-4">
            <span class="selection">{{ selection.length }}</span> {{ translationService.translate('itemsSelectionText') }}
          </div>

          <!-- TODO: Once we populate the table, lets use the commented logic to conditionally display export button
          @if (items?.length) {
            <button mat-flat-button color="accent"><mat-icon>file_download</mat-icon> Export</button>
          } -->
        </div>
      </ng-container>

      <ng-container id="table-menu" *micTableRowMenu="let item">
        @if (hasEditPermission && hasViewAndAssignCustomerPermission(item.type)) {
        <button id="assign-to-customer-button" type="button" mat-menu-item (click)="assignToCustomer(item)">
          <mat-icon>person_add_alt</mat-icon> {{ translationService.translate('assignToCustomerMenuText') }}
        </button>
        } @if (hasViewAndAssignCustomerPermission(item.type)) {
        <button id="view-assigned-customer-list-button" type="button" mat-menu-item (click)="viewAssignedCustomerList(item)">
          <mat-icon>search</mat-icon> {{ translationService.translate('viewAssignedCustomerListMenuText') }}
        </button>
        } @else if (isNafaDealerContext()) {
        <button id="nafa-action-button" type="button" mat-menu-item (click)="viewNafaAssignedCustomerList(item)">
          <mat-icon>search</mat-icon> {{ translationService.translate('viewAssignedCustomerListMenuText') }}
        </button>
        } @if (hasEditPermission && canEditNafaCam(item.type === 'NAFA')) {
        <button id="duplicate-cam-spec-button" type="button" mat-menu-item (click)="duplicateCamSpec(item)">
          <mat-icon><span class="material-icons">content_copy</span></mat-icon>
          {{ translationService.translate('duplicateCAMSpecMenuText') }}
        </button>
        } @if (item.usedBy === '0' && hasEditPermission && canDeleteCamSpec(item.type)) {
        <button id="delete-cam-spec-button" type="button" mat-menu-item (click)="showDeleteModal(item)">
          <mat-icon>delete</mat-icon> {{ translationService.translate('deleteCAMSpecMenuText') }}
        </button>
        }
      </ng-container>
    </mic-table>
  </div>
  <mic-modal class="modalC" #infoModal></mic-modal>

  <ng-template #confirmation><b>Enter a valid search string</b></ng-template>

  <mic-modal class="modalC" #saveDuplicate (result)="onModalClosed()"></mic-modal>
  <ng-template #duplicate>
    <div class="duplicate-container">
      <mat-form-field>
        <mat-label>{{ translationService.translate('camSpecNameText') }}</mat-label>
        <input
          id="duplicate-spec-name"
          matInput
          type="text"
          [formControl]="specName"
          required
          autocomplete="name"
          (input)="onNameInput(specName)"
        />
        @if (specName.hasError('required')) {
        <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
        } @if (specName.hasError('invalidSpecCode')) {
        <mat-error>{{ translationService.translate('cannotStartWithBtText') }}</mat-error>
        } @if (specName.hasError('alreadyExists')) {
        <mat-error>{{ translationService.translate('invalidCamSpecName') }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ translationService.translate('camSpecDescText') }}</mat-label>
        <input id="duplicate-spec-description" matInput type="text" [formControl]="specDescription" required autocomplete="description" />
        @if (specDescription.hasError('required')) {
        <mat-error>{{ translationService.translate('invalidCamSpecDescription') }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="flex justify-end" style="gap: 16px">
      <button id="cancel-duplicate-button" mat-flat-button (click)="cancelDulicateCamSpecModal()">
        {{ translationService.translate('cancelText') }}
      </button>
      <button
        id="save-duplicate-button"
        mat-flat-button
        color="primary"
        (click)="saveDulicateCamSpec()"
        [disabled]="specName.invalid || specDescription.invalid"
        [loading]="isSavingDuplicate"
      >
        {{ translationService.translate('saveDuplicateText') }}
      </button>
    </div>
  </ng-template>

  <mic-modal class="modalC" #viewAssigned></mic-modal>
  <ng-template #assigned>
    <div id="assign-customer-table" style="display: flex; flex-direction: column" class="ml-8">
      @if (isNafaModal) {
      <div class="flex justify-end mb-2">
        <button id="nafa-export-button" mat-flat-button color="primary" (click)="openNafaExportModal()">
          <mat-icon>file_download</mat-icon> {{ translationService.translate('exportText') }}
        </button>
      </div>
      <mic-table class="table-stripped btn-table" [config]="tableConfig2" [fetcher]="nafaCustomerTableFetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
        </ng-container>
      </mic-table>
      } @else {
      <mic-table class="table-stripped btn-table" [config]="tableConfig2" [fetcher]="customerTableFetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
        </ng-container>
      </mic-table>
      }
    </div>
  </ng-template>

  <mic-modal class="modalC" #deleteModal (result)="onDeleteModalClosed($event)"></mic-modal>

  <ng-template #deleteConfirmation
    >{{ translationService.translate('deleteCamSpecModalContentLine1Text') }} <b>{{ this.camSpecName }}</b
    >? {{ translationService.translate('deleteCamSpecModalContentLine2Text') }}</ng-template
  >
</div>
